import { useEffect } from 'react';

const useCenterMap = ({
  map,
  boundingBox,
  isAllView,
  hasW3w,
  triggerViewJurisdiction,
}) => {
  useEffect(() => {
    let bounding;
    if (Array.isArray(boundingBox) && boundingBox.length > 0) {
      bounding = boundingBox[0];
    }
    if (!hasW3w && map && isAllView && bounding) {
      try {
        const { longitude: east, latitude: south } = bounding.bottom_right;
        const { longitude: west, latitude: north } = bounding.top_left;
        map.fitBounds({ west, east, north, south });
      } catch {
        // Suppressed because this can throw when an alert is declined in CSP.
      }
    }
  }, [map, boundingBox, isAllView, hasW3w, triggerViewJurisdiction]);
};

export default useCenterMap;
